export function accordion() {
    const triggers = document.querySelectorAll('[data-js-accordion-trigger]');
    triggers.forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            e.target.classList.toggle('active');
        })
    })
}